import clsx from 'clsx'

import { UmrahTour } from 'shared/api/umrah/tours'

import { UmrahCard } from './components/umrah-card'
import s from './styles.module.scss'

interface Props {
  tours?: UmrahTour[]
}

export const UmrahCardList = ({ tours }: Props) => {
  return (
    <div className={clsx(s.cardList, 'container')}>
      {tours?.map((tour) => (
        <UmrahCard
          key={tour?.id}
          tour={tour}
        />
      ))}
    </div>
  )
}
